import { IDealBreaker } from 'redhotpie-shared-lib/interfaces/IUser';

export default class DealBreaker {
  isMatch: boolean;
  listId: number;
  text: string;
  value: number;

  constructor() {
    this.isMatch = false;
    this.listId = 0;
    this.text = '';
    this.value = 0;
  }

  static mappingObject(_obj: any): IDealBreaker {
    const dealBreaker = new DealBreaker();
    dealBreaker.isMatch = _obj.IsMatch || false;
    dealBreaker.listId = _obj.ListId || 0;
    dealBreaker.text = _obj.Text || false;
    dealBreaker.value = _obj.Value || 0;
    return dealBreaker;
  }

  static mappingObjects(_dealBreaker: any[]): IDealBreaker[] {
    return _dealBreaker && _dealBreaker.length > 0 ? _dealBreaker.map(d => DealBreaker.mappingObject(d)) : [];
  }
}
